/*eslint no-unused-vars: "off"*/
import React from 'react';
import { map, isEmpty } from 'lodash';
import moment from 'moment-timezone';
import {  Menu, Dropdown, Button  } from  'antd';
import chevronDown from '../../../../Assets/images/chevron-down.png';

class DataTable {

  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, "");
    return (
      phone?.substr(0, 3) + " " + phone?.substr(3, 3) + " " + phone?.substr(6)
    );
  };

   menu = (record,page) => {
     return( <Menu>
       <Menu.Item>
         <a href="#" className="cust-select-option"  onClick={(e) => { e.preventDefault(); page.setState({showAddons: true, currentRecord: record, transaction_type: 'view_customer'})}}>View Customer</a>
       </Menu.Item>
       <Menu.Item>
         <a href="#" className="cust-select-option" onClick={(e) => { e.preventDefault(); page.setState({showAddons: true, currentRecord: record, transaction_type: 'view_service_order'})}}>View Service Order</a>
       </Menu.Item>
     </Menu>
     )
           
   }

  ServiceToPerform = (page) => {
    const ServiceColumns = [
      {
        title: 'Customer Name',
        dataIndex: 'service__service_order__user__first_name',
        key: 'service__service_order__user__first_name',
        sorter: true,
        render: (text, record) => (<span className="type ellipse">{record?.service?.service_order?.first_name} {record?.service?.service_order?.last_name} </span>)
      },
      {
        title: 'Work Order Date/Time',
        dataIndex: 'service__scheduled_time',
        key: 'service__scheduled_time',
        sorter: true,
        render: (text, record) => (
          <b className="no-wrap">{record?.service?.scheduled_time ? moment(record?.service?.scheduled_time).format("MMM DD, YYYY"): ''} {record?.service?.scheduled_time ? moment(record?.service?.scheduled_time).format("hh:mm A"): 'Time not set'}</b>
        )
      },
      {
        title: 'Service Address',
        dataIndex: 'service__service_order__service_address__address',
        key: 'service__service_order__service_address__address',
        sorter: true,
        render: (text, record) => (
          <div>
            <span className="type ellipse">{`${record?.service?.service_order?.service_address?.address}, ${record?.service?.service_order?.service_address?.city}, ${record?.service?.service_order?.service_address?.state} ${record?.service?.service_order?.service_address?.zip_code}`}</span>
            <span className="type ellipse custom-text-muted-schedulling-error">{record?.service?.service_order?.service_address?.geo_location ? record?.service?.service_order?.service_address?.geo_location.latitude : null} {record?.service?.service_order?.service_address?.geo_location ? record?.service?.service_order?.service_address?.geo_location.longitude : null} </span>
          </div>
         
        )
      },

      {
        title: 'Work Order',
        dataIndex: 'service__work_order_number',
        key: 'service__work_order_number',
        sorter: true,
        render: (text, record) => (<span className={record?.service?.work_order_number && record?.service?.work_order_number !== null ? 'type ellipse custom-text-high-light': 'custom-text-muted-schedulling-error' }>{record?.service?.work_order_number && record?.service?.work_order_number !== null ? record?.service?.work_order_number :'Not created'} </span>)
      },
      {
        title: 'Service Order',
        dataIndex: 'service__service_order__service_order_number',
        key: 'service__service_order__service_order_number',
        sorter: true,
        render: (text, record) => (<span className="type ellipse custom-text-high-light">{record?.service?.service_order?.service_order_number} </span>)
      },
      {
        title: 'Date/Time Sent to OptimoRoute',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        render: (text, record) => (
          <b className="no-wrap">{record?.created_at ? moment(record?.created_at).format("MMM DD, YYYY"): ''} {record?.created_at ? moment(record?.created_at).format("hh:mm A"): 'Time not set'}</b>
        )
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => (<span className="type ellipse status gray-status">{record?.service?.status} </span>)
      },
      {
        render: (text, record) => {
          if(record.service.status !== 'cancelled'){
            return(
              <Dropdown overlay={this.menu(record,page)} className="cust-select-menu" placement="bottomRight" arrow>
                <span className="status-d-arrow">
                  <img src={chevronDown} alt=""/>
                </span>
              </Dropdown> 
            // <div className="position-relative status-dropdown">
            //   <div className="flex ai-center">
            //     <span className="status-d-arrow">
            //       <img src={chevronDown} alt=""/>
            //     </span>
            //   </div>
            //   <ul className="status-dropdownmenu">
            //     <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({showAddons: true, currentRecord: record, transaction_type: 'view_customer'})}}>View Customer</a></li>
            //     <li><a href="#" onClick={(e) => { e.preventDefault(); page.setState({showAddons: true, currentRecord: record, transaction_type: 'view_service_order'})}}>View Service Order</a></li>
            //   </ul>
            // </div>
            )
          }
          
        }
      }

      
    ]
    return ServiceColumns;
  }
}
export default new DataTable();